module.exports = __webpack_public_path__ + "static/media/abs.cffdc640.png";